import { Component, OnInit, Optional } from '@angular/core';
import {
    UiConfirmationDialogService,
    UiKovanSharedModule,
    UiToastMessageService,
    UiTranslateLoaderService,
} from 'ui-shared';
import { Observable, Subject } from 'rxjs';
import { TabViewModule } from 'primeng/tabview';
import { TranslateModule } from '@ngx-translate/core';
import { TabViewChangeEvent } from 'primeng/tabview/tabview.interface';
import { FileRemoveEvent, FileSelectEvent } from 'primeng/fileupload/fileupload.interface';
import { WebcamImage, WebcamInitError, WebcamModule } from 'ngx-webcam';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
    selector: 'hr-multi-type-image-uploader',
    templateUrl: './hr-multi-type-image-uploader.component.html',
    styleUrls: ['./hr-multi-type-image-uploader.scss'],
    standalone: true,
    imports: [TabViewModule, TranslateModule, UiKovanSharedModule, WebcamModule],
})
export class HrMultiTypeImageUploaderComponent implements OnInit {
    cameraError: boolean;
    uploadedImageFile = null;
    capturedImageFile = null;
    capturedImage: WebcamImage = null;
    openedTabIndex: number = 0;
    trigger: Subject<void> = new Subject<void>();

    get $trigger(): Observable<void> {
        return this.trigger.asObservable();
    }

    constructor(
        private uiToastMessageService: UiToastMessageService,
        private uiTranslateService: UiTranslateLoaderService,
        private confirmationDialogService: UiConfirmationDialogService,
        @Optional() private dialogConfig: DynamicDialogConfig,
        @Optional() public dynamicDialogRef: DynamicDialogRef,
    ) {}

    ngOnInit() {}

    onTabChange(event: TabViewChangeEvent) {
        this.openedTabIndex = event.index;
        // navigator?.mediaDevices?.getUserMedia({video: {width: 500, height: 500}}).then((response) => {
        //     this.permissionStatus = 'Allowed';
        //     this.camData = response;
        // }).catch((error) => {
        //     this.permissionStatus = 'Not Allowed';
        // });
    }

    capture(event: WebcamImage) {
        this.capturedImage = event;
        this.capturedImageFile = this.dataURLtoFile(event.imageAsDataUrl, 'image.jpeg');
    }

    captureImage() {
        this.trigger.next();
    }

    deleteImage() {
        this.capturedImage = null;
    }

    fileSelect(event: FileSelectEvent) {
        this.uploadedImageFile = event.currentFiles[0];
    }

    fileRemove(event: FileRemoveEvent) {
        this.uploadedImageFile = null;
    }

    handleInitError($event: WebcamInitError) {
        this.cameraError = true;
        console.info('handleInitError', $event);
    }

    onSave() {
        this.dynamicDialogRef.close(this.uploadedImageFile || this.capturedImageFile);
    }

    onCancel() {
        this.dynamicDialogRef.close(null);
    }

    dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    }
}
